import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorun, autorunAsync, asMap, extendObservable } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, SelectInput, TextInput, CheckBoxInput } from '../Form';

@inject('dataOriginStore', 'dataOriginParameterStore', 'parameterStore', 'parameterUnitStore', 'dataSourceStore')
@observer
class DataSourceOriginParameterEdit extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug;
  @observable dataOrigin = {
    data_source_id: 0,
    code: '',
    parameter_id: '',
    parameter_unit_id: '',
  };
  @observable dataOriginParameter = {};
  @observable parameters = [];
  dispose;

  title = 'Edit Data Origin Parameter';

  constructor(props) {
    super(props);
    const {
      params: { id, dataOriginId, dataOriginParameterId },
      dataOriginStore, dataOriginParameterStore, parameterStore, parameterUnitStore,
    } = props;
    dataOriginParameterStore.fetchItem(dataOriginParameterId);
    parameterStore.fetchItems();
    parameterUnitStore.fetchItems();
    this.init();
  }

  @action init = () => {
    const {
      params: { id, dataOriginId, dataOriginParameterId },
      dataOriginStore, parameterStore, dataOriginParameterStore,
    } = this.props;
    this.slug = `/daq/data-source/${id}/data-origin`;
    this.parameters = observable(parameterStore.items);
    this.dispose = autorunAsync(() => {
      const dataOriginParameter = dataOriginParameterStore.findById(dataOriginParameterId);
      this.dataOriginParameter = extendObservable({}, dataOriginParameter || {});

      this.dataOrigin.data_source_id = id;
      const dataOrigin = dataOriginStore.items.find(item => +item.id === +dataOriginId);
      this.dataOrigin = extendObservable(this.dataOrigin, dataOrigin);
    });
  }

  componentWillMount() {
    const {
      params: { id, dataOriginId },
      dataOriginStore, parameterStore,
    } = this.props;
  }

  componentWillUnmount() {
    this.dispose();
  }

  // @action onChangeCode = (e) => { this.dataOrigin.code = e.target.value; }
  @action onChangeCode = (e) => this.dataOriginParameter.code = e.target.value;
  @action onChangeParameter = (e) => {
    this.dataOriginParameter.parameter_id = e.target.value;
    this.dataOriginParameter.parameter_unit_id = this.props.parameterStore.findById(e.target.value).parameter_unit_id;
  }
  @action onChangeParameterUnit = (e) => this.dataOriginParameter.parameter_unit_id = e.target.value;

  @action handleSave = (e) => {
    e.preventDefault();

    const { notify } = this.context;
    const { params: { id, dataOriginId, dataOriginParameterId }, dataOriginStore, dataOriginParameterStore, dataSourceStore, parameterStore } = this.props;
    const { code, parameter_id, parameter_unit_id, block } = this.dataOriginParameter;

    dataOriginParameterStore
      .updateItem({ id: dataOriginParameterId, data_origin_id: dataOriginId, code, parameter_id, parameter_unit_id, block })
      .then(() => {
        let dataOrigin = dataSourceStore.items.filter(ds => ds.id == id)[0].origins;
        let reqDOId = null;
        dataOrigin.map(dO => {
          if (!!dO.data_origin_parameters) dO.data_origin_parameters.map(dop => {
            if (!reqDOId && dop.id == dataOriginParameterId) {
              reqDOId = dO.id;
            }
          })
        });
        let originParameter = dataSourceStore.items
          .filter(ds => ds.id == id)[0].origins
          .filter(dOrgn => dOrgn.id == reqDOId)[0].data_origin_parameters
          .filter(dop => dop.id == dataOriginParameterId)[0];
        originParameter.code = code;
        originParameter.parameter_id = parameter_id;
        originParameter.parameter_name = parameterStore.findById(parameter_id).name;
        originParameter.parameter_unit_id = parameter_unit_id;
        originParameter.block = block;
        this.context.router.push(this.slug);
        notify.success({ message: 'Updated Data Origin Parameter' });
      })
      .catch(action((err) => { notify.error(err); }));
  }

  render() {
    const { params: { id, dataOriginParameterId }, dataOriginParameterStore, parameterStore, parameterUnitStore } = this.props;

    if (dataOriginParameterStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={dataOriginParameterStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Code'} value={this.dataOriginParameter.code} onChange={this.onChangeCode} />

            <SelectInput
              label={'Parameter'}
              fields={{ label: 'name', value: 'id' }}
              value={this.dataOriginParameter.parameter_id}
              options={parameterStore.items.toJS().sort((a, b) => { return a.name < b.name ? -1 : 1 })}
              onChange={this.onChangeParameter}
              filterOptions={parameterStore.filterParameters}
            />

            <SelectInput
              label={'Parameter Unit'}
              fields={{ label: 'name', value: 'id' }}
              options={parameterUnitStore.items.toJS()}
              value={this.dataOriginParameter.parameter_unit_id}
              onChange={this.onChangeParameterUnit}
            />

            <CheckBoxInput
              label={'Block'}
              checked={+this.dataOriginParameter.block === 1}
              onChange={e => this.dataOriginParameter.block = ~this.dataOriginParameter.block + 2}
            />

          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default DataSourceOriginParameterEdit;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceOriginParameterEdit.js